const locale = {
    placeholder: '날짜 선택',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/ko_KR.tsx